/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Doc recognition error: file type not supported
 * @export
 * @interface PaxCheckFileTypesNotSupported
 */
export interface PaxCheckFileTypesNotSupported {
    /**
     * Which document types were provided
     * @type {Array<string>}
     * @memberof PaxCheckFileTypesNotSupported
     */
    providedFileTypes: Array<string>;
    /**
     * Which document types are supported
     * @type {Array<string>}
     * @memberof PaxCheckFileTypesNotSupported
     */
    supportedFileTypes: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PaxCheckFileTypesNotSupported
     */
    type: string;
}

/**
 * Check if a given object implements the PaxCheckFileTypesNotSupported interface.
 */
export function instanceOfPaxCheckFileTypesNotSupported(value: object): value is PaxCheckFileTypesNotSupported {
    if (!('providedFileTypes' in value) || value['providedFileTypes'] === undefined) return false;
    if (!('supportedFileTypes' in value) || value['supportedFileTypes'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function PaxCheckFileTypesNotSupportedFromJSON(json: any): PaxCheckFileTypesNotSupported {
    return PaxCheckFileTypesNotSupportedFromJSONTyped(json, false);
}

export function PaxCheckFileTypesNotSupportedFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckFileTypesNotSupported {
    if (json == null) {
        return json;
    }
    return {
        
        'providedFileTypes': json['provided_file_types'],
        'supportedFileTypes': json['supported_file_types'],
        'type': json['type'],
    };
}

export function PaxCheckFileTypesNotSupportedToJSON(json: any): PaxCheckFileTypesNotSupported {
    return PaxCheckFileTypesNotSupportedToJSONTyped(json, false);
}

export function PaxCheckFileTypesNotSupportedToJSONTyped(value?: PaxCheckFileTypesNotSupported | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'provided_file_types': value['providedFileTypes'],
        'supported_file_types': value['supportedFileTypes'],
        'type': value['type'],
    };
}

